/* eslint-disable */
<template>
  <v-container fluid class="px-5">
    <v-layout>
      <v-flex class="d-flex" :class="{ 'flex-column': $vuetify.breakpoint.smAndDown }">
        <div class="d-flex flex-row my-auto">
          <v-btn
            :block="$vuetify.breakpoint.width <= 400"
            rounded
            outlined
            color="primary"
            min-width="120px"
            @click="csvExport(null)"
          >
            <v-icon>cloud_download</v-icon>&nbsp;Download
          </v-btn>

          <v-dialog v-model="uploadFileDialog" width="500" persistent>
            <template v-slot:activator="{ on }">
              <v-btn
                rounded
                outlined
                color="primary"
                min-width="120px"
                class="ml-2"
                v-on="on"
                v-show="$vuetify.breakpoint.smAndUp && allowUpload"
              >
                <v-icon>cloud_upload</v-icon> &nbsp; Upload
              </v-btn>
            </template>

            <v-card>
              <v-card-text>
                <v-layout row wrap pt-10>
                  <v-flex xs12 mt-5 mb-10 mx-5 v-show="false">
                    <p class="body-1 mb-2 black--text">
                      ประเภทเอกสาร
                    </p>
                    <v-select
                      v-model="documentTypeSelect"
                      :items="documentTypeItems"
                      item-text="name"
                      item-value="value"
                      no-data-text="ไม่พบข้อมูล"
                      label="เลือกประเภทเอกสาร"
                      class="card-border"
                      flat
                      solo
                      hide-details
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 v-show="fileDataTemp !== null" class="text-center">
                    <v-icon x-large>insert_drive_file</v-icon>
                    <p>{{ fileNameTemp }}</p>
                  </v-flex>
                  <v-flex xs12 class="text-center">
                    <v-btn
                      outlined
                      rounded
                      class="ma-0 mt-2"
                      color="primary"
                      @click="uploadFileClicked"
                      v-show="fileDataTemp === null"
                      min-width="120"
                      >เลือกไฟล์</v-btn
                    >
                    <p v-show="fileDataTemp === null" class="caption text-center">
                      หมายเหตุ : รองรับ csv, xls, xlsx และบันทึกเป็น UTF-8 เท่านั้น
                      <!-- หมายเหตุ : รองรับ doc, pdf, xls, xlsx, csv, png, jpeg เท่านั้น -->
                    </p>
                  </v-flex>
                </v-layout>
                <input
                  type="file"
                  style="display: none"
                  ref="uploadFile"
                  accept=".csv, .xls, .xlsx"
                  v-if="uploadFileReady"
                  @change="onFilePicked($event, uploadTargetIndex)"
                />
                <!-- accept="application/msword, application/vnd.ms-excel, application/pdf, image/png, image/jpeg" -->
              </v-card-text>
              <v-alert
                class="ma-0 pb-0 text-xs-left no-outline"
                :value="true"
                color="warning"
                icon="priority_high"
                outlined
                v-show="uploadFileWarningText !== ''"
                >{{ uploadFileWarningText }}</v-alert
              >
              <v-divider></v-divider>
              <v-card-actions class="pa-4">
                <v-btn
                  rounded
                  color="primary"
                  :href="getCSVFile(csvfile)"
                  min-width="90"
                  download
                  target="_blank"
                  >ตัวอย่าง</v-btn
                >
                <v-spacer></v-spacer>
                <v-btn rounded text @click="cancelUploadFileData">ยกเลิก</v-btn>
                <v-btn rounded color="primary" min-width="90" @click="confirmUploadFileData"
                  >ยืนยัน</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
        <div class="mt-4 mt-md-0 d-flex flex-row">
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-width="200"
            max-height="350"
            offset-y
          >
            <!--template v-slot:activator="{ on }">
              <v-btn rounded outlined color="primary" v-on="on">ตัวกรอง</v-btn>
            </template-->

            <v-card>
              <v-list
                v-for="o in departmentItems"
                :key="o.id"
                @click.capture.stop="toggleDepartment(o)"
              >
                <v-list-item>
                  <v-list-item-action>
                    <v-checkbox
                      v-model="departmentSelect"
                      :value="o"
                      class="mt-0 mx-2 pt-0"
                      :label="`${o.name} (${getDepartmentLength(o.name)})`"
                      color="primary"
                    ></v-checkbox>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </v-card>
          </v-menu>

          <!--p class="summary ma-0 pa-0 d-flex align-center">&emsp;|&emsp;</p-->
        </div>
        <v-row>
          <v-col cols="3" class="pr-2 my-auto">
            <div
              class="summary subtitle-2 font-weight-medium ma-0 ml-4 pa-0 d-flex list-header-text number"
              style="width:140px;margin-bottom:2px !important;"
            >
              <span style="padding-top: 2px;">รวม {{ dataDepartmentFilter.length | numFormat }} รายการ</span>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="primary" dark class="ml-1" v-bind="attrs" v-on="on">fa-info-circle</v-icon>
                </template>
                <span
                  >ยานพาหนะ {{ dataDepartmentFilter.reduce((a, b) => (a + b.vehicle), 0) | numFormat }} คัน<br />
                  ผู้เสียชีวิต {{ dataDepartmentFilter.reduce((a, b) => (a + b.dead), 0) | numFormat }} คน<br />
                  ผู้บาดเจ็บ {{ dataDepartmentFilter.reduce((a, b) => (a + b.injury), 0) | numFormat }} คน</span
                >
              </v-tooltip>
            </div>
          </v-col>
          <v-col cols="2" class="pr-0 my-auto">
            <p
              class="summary subtitle-2 font-weight-medium ma-0 pa-0 d-flex align-baseline list-header-text"
            >
              จำนวนผู้บาดเจ็บ
            </p>
          </v-col>
          <v-col cols="2" class="pl-0 my-auto">
            <v-text-field
              v-model="filterinjure"
              :dense="true"
              :clearable="true"
              suffix="คน"
              @click:clear="filterReport"
              @keydown="filterReport"
            ></v-text-field>
          </v-col>
          <v-col cols="2" class="pr-0 my-auto">
            <p
              class="summary subtitle-2 font-weight-medium ma-0 pa-0 d-flex align-baseline list-header-text"
            >
              จำนวนผู้เสียชีวิต
            </p>
          </v-col>
          <v-col cols="2" class="pl-0 my-auto">
            <v-text-field
              v-model="filterdeath"
              :dense="true"
              :clearable="true"
              suffix="คน"
              @click:clear="filterReport"
              @keydown="filterReport"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-flex>
    </v-layout>
    <v-row v-show="isfrommap">
      <v-col class="title text-center">รายการค้นหาจากหน้าแผนที่</v-col>
    </v-row>
    <AlertDialog
      v-model="alertDialog"
      :status="isServiceSuccess ? 'success' : 'error'"
      v-on:ok-btn-click="alertDialog = false"
      >{{ alertDialogMessage }}
    </AlertDialog>
    <v-data-table
      :headers="reportHeader"
      :items="dataDepartmentFilter"
      :items-per-page="10"
      :footer-props="footerProps"
      :sort-by="['raw_date', 'accident_time']"
      :sort-desc="[true, true]"
      loading-text="กำลังโหลดข้อมูล"
      no-data-text="ไม่พบข้อมูล"
      class="elevation-0 mt-4 report-table"
      :hide-default-footer="dataDepartmentFilter.length == 0"
      :mobile-breakpoint="0"
    >
      <template v-slot:item="props">
        <tr>
          <!-- <td>
            <v-icon color="primary" v-if="props.item.is_lock == true">lock</v-icon>
            <v-icon v-else>lock_open</v-icon>
          </td>-->
          <td class="no-new-line">{{ props.item.id }}</td>
          <td class="no-new-line">{{ displayData(props.item.accident_date, 'raw_date') }}</td>
          <td class="no-new-line">{{ displayData(props.item.accident_time, 'accident_time') }}</td>
          <td v-if="role !== 'BMTA'">
            {{
              props.item.department === 'EXAT'
                ? displayData(props.item, 'route_code')
                : displayRouteCode(props.item.department, props.item)
            }}
          </td>
          <td v-if="role !== 'BMTA'">
            {{ displayData(props.item, 'km') }}
          </td>
          <td v-else-if="['ADMIN', 'SYSTEM'].indexOf(role) != -1" :colspan="2">
            {{ displayData(props.item, 'route_code') }}
          </td>
          <td v-else>{{ displayData(props.item, 'route_code') }}</td>
          <td>{{ displayData(props.item, 'vehicle') }}</td>
          <td class="no-new-line">{{ displayData(props.item.dead, 'dead') }}</td>
          <td class="no-new-line">{{ displayData(props.item.injury, 'injury') }}</td>
          <td class="no-new-line">{{ displayData(props.item.department_th, 'department') }}</td>
          <td class="text-left no-new-line">
            <v-icon
              class="ml-2"
              color="primary"
              v-on="on"
              @click.stop="openRecord(props.item, false)"
              >description</v-icon
            >
            <!--v-icon class="ml-2" color="primary" @click="csvExport(props.item.id)"
              >cloud_download</v-icon
            -->
            <v-icon
              class="ml-2"
              v-if="
                (isMasterAdmin || roleDepartment == props.item.department) &&
                  ('BMTA' == props.item.department.toUpperCase() ||
                    'SRT' == props.item.department.toUpperCase())
              "
              color="primary"
              @click="openRecord(props.item, true, props.item.department.toUpperCase())"
              >edit</v-icon
            >
            <v-icon
              v-if="isMasterAdmin || roleDepartment == props.item.department"
              class="ml-2"
              color="primary"
              @click="deleteRecord(props.item)"
              >delete</v-icon
            >
          </td>
        </tr>

        <v-dialog
          :id="`dialog-datail-${props.item.id}`"
          v-model="dialogDatail[props.item.id]"
          width="80%"
          scrollable
        >
          <!-- dialog -->
          <v-card>
            <v-card-title class="v-card-title">
              <span class="title text-left primary--text font-weight-medium">ข้อมูลอุบัติเหตุ</span>
              <v-icon color="#BA4438" @click.stop="$set(dialogDatail, props.item.id, false)"
                >close</v-icon
              >
            </v-card-title>
            <v-card-text>
              <v-container>
                <Detail class="print-detail" :accident="props.item" />
              </v-container>
            </v-card-text>
            <v-card-actions class="align-end" style="padding: 20px; padding-top: 0;">
              <v-btn
                :block="$vuetify.breakpoint.xsOnly"
                rounded
                outlined
                width="120"
                color="primary"
                class="mt-2"
                @click.stop="prtintRecord(props.item.id)"
                >พิมพ์รายงาน</v-btn
              >
              <v-spacer></v-spacer>
              <v-btn
                :block="$vuetify.breakpoint.xsOnly"
                rounded
                width="120"
                color="primary"
                class="mt-2 ml-2"
                @click.stop="$set(dialogDatail, props.item.id, false)"
                >ปิด</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template v-slot:footer.page-text="props"
        >{{ props.pageStart }} - {{ props.pageStop }} จาก {{ props.itemsLength }}</template
      >
    </v-data-table>
  </v-container>
</template>

<script>
import { access } from 'fs';
import cloneDeep from 'clone-deep';
import { isNull } from 'util';
import Detail from './Detail.vue';
import AlertDialog from '../global/AlertDialog.vue';

const qs = require('qs');

export default {
  name: 'List',
  components: {
    Detail,
    AlertDialog
  },
  props: {
    searchCondition: {
      type: Object
    },
    allowUpload: {
      type: Boolean
    },
    roleDepartment: {
      type: String
    }
  },
  data: () => ({
    csvfile: localStorage.getItem('username') ? localStorage.getItem('username').split('.')[0] : '',
    menu: false,
    footerProps: {
      itemsPerPageOptions: [],
      itemsPerPageText: 'จำนวนแถวที่แสดง',
      disableItemsPerPage: true
    },
    userDepartment: null,
    departmentSelect: [],
    departmentSearch: null,
    departmentItems: [],
    reportData: [],
    isconstset: false,
    conreportData: [],
    on: false,
    dialogDatail: {},
    //
    uploadFileDialog: false,
    uploadFileReady: true,
    uploadFileWarningText: '',
    fileNameTemp: null,
    fileDataTemp: null,
    documentTypeSelect: 'accident',
    documentTypeItems: [
      {
        value: 'accident',
        name: 'อุบัติเหตุ'
      },
      {
        value: 'vehicle',
        name: 'ยานพาหนะ'
      },
      {
        value: 'person',
        name: 'ผู้ใช้ทาง'
      }
    ],
    //
    alertDialog: false,
    alertDialogMessage: '',
    isServiceSuccess: true,
    filterdeath: '',
    filterinjure: '',
    isfrommap: false,
    role: localStorage.getItem('role'),
    forceReload: false
  }),
  created() {
    this.getDepartmentLists();
  },
  mounted() {},
  methods: {
    init() {},
    filterReport() {
      setTimeout(() => {
        if (!this.filterdeath && !this.filterinjure) {
          this.reportData = cloneDeep(this.conreportData);
        } else {
          let tempreport = cloneDeep(this.conreportData);
          if (this.filterdeath) {
            tempreport = tempreport.filter(member => {
              return member.dead == parseInt(this.filterdeath, 10);
            });
            this.reportData = cloneDeep(tempreport);
          }
          if (this.filterinjure) {
            tempreport = tempreport.filter(member => {
              return member.injury == parseInt(this.filterinjure, 10);
            });
            this.reportData = cloneDeep(tempreport);
          }
        }
      }, 200);
    },
    getDepartmentLists() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/department`;

      this.axios
        .get(url)
        .then(response => {
          if (response.status === 200 && response.data.data) {
            scope.departmentItems = response.data.data;
            scope.departmentItems.forEach(function(item) {
              if (item.name.toUpperCase() == scope.roleDepartment.toUpperCase()) {
                scope.departmentSelect.push(item);
              }
            });

            if (scope.departmentSelect.length == 0) {
              scope.departmentSelect = scope.departmentItems;
            }

            // scope.getReportData();
          }
        })
        .catch(function(error) {
          scope.departmentSelect = scope.departmentItems = [];
          console.log(error);
        });
    },
    getReportData() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/service/get/accident?`;

      // if (this.departmentSearch) {
      //   url += `depertment=${this.departmentSearch[0].id}&`;
      // }

      this.reportData = [];
      let accidentList = localStorage.getItem('accidentList');
      // let request;
      if (accidentList) {
        accidentList = accidentList.split(',');
        for (let i = 0; i < accidentList.length; i += 800) {
          this.axios
            .post(url, `id=${accidentList.slice(i, i + 800)}`)
            .then(response => {
              if (response.status === 200) {
                scope.reportData = scope.reportData.concat(response.data.data);
              }
              if (scope.reportData.length == accidentList.length) {
                scope.lockData();
              }
            })
            .catch(function(error) {
              scope.reportData = [];
              console.log(error);
            });
        }
        this.isfrommap = true;
        const accStDate = localStorage.getItem('accidentListStDate');
        const accEdDate = localStorage.getItem('accidentListEdDate');
        const accProvice = localStorage.getItem('accidentListProvince');
        const accDepartment = localStorage.getItem('accidentListDepartment');
        const accRoad = localStorage.getItem('accidentListRoad');
        const defaultFromMapObj = {
          start_date: accStDate,
          end_date: accEdDate,
          province: accProvice,
          department: accDepartment,
          road: accRoad
        };
        this.$emit('setDefaultDateFromMap', defaultFromMapObj);
        localStorage.removeItem('accidentList');
        localStorage.removeItem('accidentListStDate');
        localStorage.removeItem('accidentListEdDate');
        localStorage.removeItem('accidentListProvince');
        localStorage.removeItem('accidentListDepartment');
        localStorage.removeItem('accidentListRoad');
      } else {
        const param = scope.getSearchConditionParams();
        if (this.forceReload) {
          param.force_load = 'true';
          this.forceReload = false;
        }
        this.axios
          .get(url, { params: param })
          .then(response => {
            if (response.status === 200) {
              scope.reportData = response.data.data;
              this.isfrommap = false;
              scope.lockData();
            }
          })
          .catch(function(error) {
            scope.reportData = [];
            const { response } = error;
            if (response.status === 401) {
              console.log('unauthorized');
              scope.$router.push({ name: 'unauthorized' });
            } else {
              console.log(error);
            }
          });
      }
      this.conreportData = cloneDeep(this.reportData);
      // request.then(response => {
      //     if (response.status === 200) {
      //       scope.reportData = response.data.data;
      //       scope.lockData();
      //     }
      //   })
      //   .catch(function(error) {
      //     scope.reportData = [];
      //     console.log(error);
      //   });
    },
    search() {
      this.isconstset = false;
      this.getReportData();
    },
    getDepartmentLength(value) {
      const department = this.reportData.filter(function(u) {
        return u.department === value;
      });

      return department.length;
    },
    lockData() {
      const self = this;
      try {
        this.reportData = this.reportData.map(item => {
          item.raw_date = self.ConvertToDateValue(item.accident_date);
          item.is_lock = true;
          return item;
        });
      } catch (error) {
        console.error(error);
      }
    },
    ConvertToDateValue(thaiDate) {
      const thaiMonth = [
        'ม.ค.',
        'ก.พ.',
        'มี.ค.',
        'เม.ย.',
        'พ.ค.',
        'มิ.ย.',
        'ก.ค.',
        'ส.ค.',
        'ก.ย.',
        'ต.ค.',
        'พ.ย.',
        'ธ.ค.'
      ];
      const split = thaiDate.split(' ');
      let day = split[0];
      let month = thaiMonth.indexOf(split[1]) + 1;
      const year = parseInt(split[2]) - 543;
      if (month < 10) month = `0${month}`;
      if (day.length < 2) day = `0${day}`;
      return [year, month, day].join('-');
    },
    getColumnTitle(value) {
      if (value == 'route_code') {
        if (!this.searchCondition) {
          return 'สายทาง';
        }
        switch (this.searchCondition.department) {
          case '7':
            return 'ขบวน';
          case '9':
            return 'สถานที่เกิดเหตุ';
          case '10':
          case '11':
            return 'สถานี';
          case '14':
            return 'ประเภทสถานที่';
          default:
            return 'สายทาง';
        }
      } else if (value == 'km') {
        if (!this.searchCondition) {
          return 'กม.';
        }
        switch (this.searchCondition.department) {
          case '9':
            return 'ระดับของเหตุการณ์';
          case '10':
          case '11':
            return 'ประเภทเหตุการณ์';
          case '14':
            return 'สาเหตุ';
          default:
            return 'กม.';
        }
      } else if (value == 'vehicle') {
        if (!this.searchCondition) {
          return 'ยานพาหนะ';
        }
        switch (this.searchCondition.department) {
          case '10':
          case '11':
            return 'ระดับเหตุการณ์';
          default:
            return 'ยานพาหนะ';
        }
      }
    },
    displayData(data, field) {
      if (!data) return '-';
      if (field == 'route_code') {
        if (!this.searchCondition) {
          return data.route_code || '-';
        }
        switch (this.searchCondition.department) {
          case '3':
          case '5':
            return data.route_name || '-';
          case '9':
            return data.airname || '-';
          case '10':
          case '11':
            return data.station || '-';
          case '14':
            return data.marine_type || '-';
          default:
            return data.route_code || '-';
        }
      } else if (field == 'km') {
        if (!this.searchCondition) {
          return data.km || '-';
        }
        switch (this.searchCondition.department) {
          case '9':
            return data.occurrence_class || '-';
          case '10':
          case '11':
            return data.category || '-';
          case '14':
            return data.cause_specify || '-';
          default:
            return data.km || '-';
        }
      } else if (field == 'vehicle') {
        if (!this.searchCondition) {
          return data.vehicle || '-';
        }
        switch (this.searchCondition.department) {
          case '10':
          case '11':
            return data.class || '-';
          default:
            return data.vehicle || '-';
        }
      }
      return data;
    },
    displayRouteCode(department, route) {
      if (department != 'SRT' || route.route_code == 'ขบวนอื่นๆ') {
        return this.displayData(route, 'route_code');
      }
      if (!route.route_code) {
        return '-';
      }

      return `ขบวน ${this.displayData(route, 'route_code')}`;
    },

    csvExport(id) {
      let arrData =
        id == null
          ? this.dataDepartmentFilter
          : [
              this.dataDepartmentFilter.find(function(u) {
                return u.id == id;
              })
            ];
      arrData = arrData.map(function(data) {
        const a = {};
        const fields = [
          'cause_user',
          'cause_surround',
          'cause_vehicle'
        ];
        const idNameFields = [
          'crash_pattern',
          'surround_road',
        ];
        const unused = ['raw_date', 'is_lock', 'vehicle_data', 'casualty_data'];
        for (const attr in data) {
          if (unused.indexOf(attr) == -1) {
            if (!data[attr]) {
              a[attr] = '';
            } else if (attr == 'location') {
              a.latitude = data.location.latitude;
              a.longitude = data.location.longitude;
            } else if (idNameFields.indexOf(attr) != -1) {
              a[attr] = data[attr].name;
            } else if (fields.indexOf(attr) != -1) {
              a[attr] = `"${data[attr].map(el => el.name).join(',')}"`;
            } else {
              a[attr] = `"${`${data[attr]}`.replace(/"/g, '""')}"`;
            }
          }
        }
        return a;
      });
      let csvContent = 'data:text/csv;charset=utf-8,\uFEFF';
      csvContent += [
        Object.keys(arrData[0]).join(','),
        ...arrData.map(item => Object.values(item).join(','))
      ].join('\n');

      const data = encodeURI(csvContent);
      const link = document.createElement('a');
      link.setAttribute('href', data);
      link.setAttribute('download', this.getDownloadFilename());
      link.click();
    },
    getDownloadFilename() {
      const name = this.utils
        .getLocalTime()
        .toJSON()
        .substring(0, 19)
        .replace('T', '_')
        .replace(/-|:/g, '');
      return `${name}.csv`;
    },
    toggleDepartment(depart) {
      if (this.departmentSelect.includes(depart)) {
        this.departmentSelect.splice(this.departmentSelect.indexOf(depart), 1);
      } else {
        this.departmentSelect.push(depart);
      }
    },
    deleteRecord(item) {
      const scope = this;
      if (confirm(`ยืนยันลบรายการ ${item.id} ?`)) {
        const url = `${process.env.VUE_APP_SERVICE_API_URL}/service/delete/accident?`;
        const data = {
          id: item.id
        };

        this.axios
          .post(url, qs.stringify(data))
          .then(response => {
            if (response.status == 200) {
              scope.setupAlertDialog(true, 'ลบข้อมูลสำเร็จ');
              setTimeout(function() {
                scope.forceReload = true;
                scope.getReportData();
              }, 500);
            }
          })
          .catch(function(error) {
            scope.setupAlertDialog(false, error.response.data.message);
            console.log(error);
          });
      }
    },
    // editRecord(id) {
    //   alert(`edit ${id}`);
    // },
    // reportRecord(item) {
    //   this.$cookies.set(`acc-${item.id}`, JSON.stringify(item), '5min');
    //   const routeData = this.$router.resolve({
    //     name: 'report_detail',
    //     query: { data: item.id, isEdit: false },
    //   });
    //   window.open(routeData.href, '_blank');
    // },
    openRecord(item, isEdit, department = '') {
      this.$cookies.set(`acc-${item.id}`, JSON.stringify(item), '5min');
      const routeName = department === 'BMTA' ? 'addinfo_bus' : 'addinfo_train';
      const routeData = this.$router.resolve({
        name: isEdit ? routeName : 'report_detail',
        query: { data: item.id }
      });
      window.open(routeData.href, '_blank');
    },
    prtintRecord(id) {
      const modal = document.getElementById(`dialog-datail-${id}`);
      const cloned = modal.cloneNode(true);
      let section = document.getElementById('print');

      if (!section) {
        section = document.createElement('div');
        section.id = 'print';
        document.body.appendChild(section);
      }

      section.innerHTML = '';
      section.appendChild(cloned);
      window.print();
    },
    downloadRecord(id) {
      alert(`download ${id}`);
    },
    getSearchConditionParams() {
      const searchParams = {};
      if (this.searchCondition != null) {
        Object.keys(this.searchCondition).forEach(param => {
          if (
            this.searchCondition[param] !== null &&
            this.searchCondition[param] !== '' &&
            this.searchCondition[param] !== '0' &&
            this.searchCondition[param] !== 0
          ) {
            searchParams[param] = this.searchCondition[param];
          }
        });
        return searchParams;
      }

      return {};
    },
    // upload file
    uploadDocumentFile() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/upload/accident`; // ${this.documentTypeSelect}`;

      // if (this.departmentSearch) {
      //   url += `depertment=${this.departmentSearch[0].id}&`;
      // }

      this.reportData = [];

      this.axios
        .post(url, scope.getUploadDocumentFileParams())
        .then(response => {
          // if (response.code === 200) {
          //   scope
          // }
          setTimeout(function() {
            scope.forceReload = true;
            scope.getReportData();
          }, 2000);
          scope.setupAlertDialog(response.status === 200, response.data.data.message);
          scope.resetUploadFileDataTemp();
        })
        .catch(error => {
          if (error.response.data.message) {
            if (error.response.data.message.indexOf('ORA-') != -1) {
              const pos = error.response.data.message.indexOf('ORA-') + 11;
              scope.setupAlertDialog(false, error.response.data.message.substr(pos));
            } else {
              scope.setupAlertDialog(false, error.response.data.message);
            }
          } else {
            scope.setupAlertDialog(
              false,
              `เกิดข้อผิดพลาด โปรดลองอีกครั้งในภายหลัง (Error ${error.response.status || '0'})`
            );
          }
          scope.resetUploadFileDataTemp();
          console.log(error);
        });
    },
    getUploadDocumentFileParams() {
      const formData = new FormData();
      formData.append('file', this.fileDataTemp);
      formData.append('username', localStorage.getItem('username'));

      return formData;
    },
    uploadFileClicked() {
      this.uploadTargetIndex = null;
      this.pickFile();
    },
    getCSVFile(dept) {
      return `${process.env.VUE_APP_SERVICE_API_URL}/csv_template/${dept}.${
        dept == 'mrt' ? 'zip' : 'csv'
      }`;
    },
    pickFile() {
      this.$refs.uploadFile.click();
    },
    onFilePicked(e, target) {
      // target is tableFileData index
      const { files } = e.target;
      let filename = '';
      let fileUrl = '';
      let currentFile = '';
      if (files[0] !== undefined) {
        filename = files[0].name;
        if (filename.lastIndexOf('.') <= 0) {
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener('load', () => {
          fileUrl = fr.result;
          currentFile = files[0]; // this is an image file that can be sent to server...

          if (target === null) {
            // if null then push into tableFileData
            this.fileDataTemp = currentFile;
            this.fileNameTemp = filename;
          } else {
            // if not null then set file into tableFileData[target].input_realpath
            this.tableFileDataTemp[target].input_realpath = currentFile;
          }

          this.clearUploadFileInput();
        });
      } else {
        // TODO : show upload file alert error
      }
    },
    confirmUploadFileData() {
      if (/* this.documentTypeSelect !== '' && */ this.fileDataTemp) {
        this.uploadDocumentFile();
        // this.tableFileDataTemp.push({
        //   id: "",
        //   input_filename: "",
        //   title_filename: this.fileTitleTemp,
        //   attachment_code: "2",
        //   input_realpath: this.fileDataTemp
        // });
        // this.resetUploadFileDataTemp();
      } else {
        const warning = [];
        let warningText = 'กรุณา';
        if (this.documentTypeSelect === null || this.documentTypeSelect === '') {
          warning.push('กรุณาเลือกประเภทเอกสาร');
        }
        if (this.fileDataTemp === null) {
          warning.push('เลือกไฟล์');
        }
        warningText += warning.join(' และ ');

        this.uploadFileWarningText = warningText;
      }
    },
    cancelUploadFileData() {
      this.resetUploadFileDataTemp();
    },
    resetUploadFileDataTemp() {
      this.uploadFileDialog = false;
      this.fileNameTemp = null;
      this.fileDataTemp = null;
      this.uploadFileWarningText = '';
      this.documentTypeSelect = '';

      this.clearUploadFileInput();
    },
    clearUploadFileInput() {
      this.uploadFileReady = false;
      this.$nextTick(() => {
        this.uploadFileReady = true;
      });
    },
    // Alert Dialog
    setupAlertDialog(isServiceSuccess, message) {
      this.isServiceSuccess = isServiceSuccess;
      this.alertDialogMessage = message;
      this.alertDialog = true;
    }
  },
  computed: {
    reportHeader() {
      if (this.role !== 'BMTA') {
        return [
          {
            text: 'รหัส',
            align: 'center',
            sortable: true,
            value: 'id',
            width: '7%',
            fixed: true
          },
          {
            text: 'วันที่',
            align: 'center',
            sortable: true,
            value: 'raw_date',
            width: '10%',
            fixed: true
          },
          {
            text: 'เวลา',
            align: 'center',
            sortable: true,
            value: 'accident_time',
            width: '7%',
            fixed: true
          },
          {
            text: this.getColumnTitle('route_code'),
            align: 'center',
            sortable: true,
            value: 'route_code',
            width: '25%',
            fixed: true
          },
          {
            text: this.getColumnTitle('km'),
            align: 'center',
            sortable: true,
            value: 'km',
            width: '10%',
            fixed: true
          },
          {
            text: this.getColumnTitle('vehicle'),
            align: 'center',
            sortable: true,
            value: 'vehicle',
            width: '7%',
            fixed: true
          },
          {
            text: 'ผู้เสียชีวิต',
            align: 'center',
            sortable: true,
            value: 'dead',
            width: '7%',
            fixed: true
          },
          {
            text: 'ผู้บาดเจ็บ',
            align: 'center',
            sortable: true,
            value: 'injury',
            width: '7%',
            fixed: true
          },
          {
            text: 'หน่วยงาน',
            align: 'center',
            sortable: true,
            value: 'department',
            width: '7%',
            fixed: true
          }
        ];
      }

      return [
        {
          text: 'รหัส',
          align: 'center',
          sortable: true,
          value: 'id',
          width: '7%',
          fixed: true
        },
        {
          text: 'วันที่',
          align: 'center',
          sortable: true,
          value: 'raw_date',
          width: '10%',
          fixed: true
        },
        {
          text: 'เวลา',
          align: 'center',
          sortable: true,
          value: 'accident_time',
          width: '7%',
          fixed: true
        },
        {
          text: ' ถนน',
          align: 'center',
          sortable: true,
          value: 'route_name',
          width: '28%',
          fixed: true
        },
        {
          text: 'ยานพาหนะ',
          align: 'center',
          sortable: true,
          value: 'vehicle',
          width: '15%',
          fixed: true
        },
        {
          text: 'ผู้เสียชีวิต',
          align: 'center',
          sortable: true,
          value: 'dead',
          width: '7%',
          fixed: true
        },
        {
          text: 'ผู้บาดเจ็บ',
          align: 'center',
          sortable: true,
          value: 'injury',
          width: '7%',
          fixed: true
        },
        {
          text: 'หน่วยงาน',
          align: 'center',
          sortable: true,
          value: 'department',
          width: '7%',
          fixed: true
        }
      ];
    },
    dataDepartmentFilter() {
      const department = [];
      this.departmentSelect.forEach(function(o) {
        department.push(o.name);
      });

      const result = this.reportData.filter(function(u) {
        return department.includes(u.department);
      });
      if (!this.isconstset && result.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.conreportData = cloneDeep(result);
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.isconstset = true;
      }
      return result;
    },
    isMasterAdmin() {
      const user = localStorage.getItem('username');
      return this.roleDepartment == 'ADMIN' && user == 'admin';
    }
  },
  watch: {
    searchCondition(val) {
      if (this.departmentItems) {
        this.departmentSearch = this.departmentItems.filter(function(u) {
          return u.id === val.department;
        });
      }
      this.search();
    },
    allowUpload(val) {
      console.log(val);
    },
    roleDepartment(val) {
      console.log(val);
    }
  }
};
</script>

<style lang="scss" scoped>
.col,
.v-list {
  padding-top: 0;
  padding-bottom: 0;
}

.listitem {
  padding: 0 !important;
  min-height: unset;
}

.listaction {
  margin: 0 !important;
}

.summary {
  margin-bottom: 0;
}

.dialog {
  margin: auto;
}

.v-card-title {
  border-bottom: 1px solid #cfcfcf;
  justify-content: space-between;
}

div.v-alert.no-outline {
  border: 0px !important;
  width: fit-content;
  margin: auto !important;
}

::v-deep th {
  white-space: nowrap;
}

.report-table table {
  table-layout: fixed;
}

.report-table tr > * {
  padding: 0 4px !important;
}
</style>
